import { Scopable } from '../Interface/Scopable';
import arrayUnique from 'array-unique';

const reduceRulesToScopeNames = (rules: Scopable[]): string[] => arrayUnique(rules.map(rule => rule.scope));

export default reduceRulesToScopeNames;
